import { NgOptimizedImage } from '@angular/common';
import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ButtonModule, DrawerModule, NgOptimizedImage],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  host: {
    class: 'flex flex-column h-full',
  },
})
export class App {
  readonly isSidemenuOpened = signal(false);
}
